import React, { memo } from 'react';
import { GoogleTagManager } from './GoogleTagManager';
export const PriorityThirdPartyScripts = memo<{}>(() => <GoogleTagManager />);
